<template>
  <div class="modal fade createNewModal" id="genererFactureModal" tabindex="-1" aria-hidden="true"
    ref="genererFactureModalRef">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
          <h5 class="modal-title fw-bold text-black">Génération de factures</h5>
        </div>
        <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
          <Form ref="factureForm" @submit="genererFactures" :validation-schema="factureSchema">
            <div class="row mb-10">
              <div class="col-12 d-flex justify-content-end">
                <div class="form-group radio-group-right">
                  <div class="d-flex align-items-center gap-15">
                    
                    <div class="form-check me-3">
                        <Field name="natureFacture" type="radio" :value="3" id="3"
                        class="form-check-input" v-model="natureFacture" checked />
                      <label class="form-check-label" for="3">
                        Loyer & Electricité
                      </label>
                    </div>
                    <div class="form-check me-3">
                      <Field name="natureFacture" type="radio" :value="0" id="0"
                        class="form-check-input" v-model="natureFacture" />
                      <label class="form-check-label" for="0">
                        Loyer
                      </label>
                    </div>
                    <div class="form-check me-3">
                      <Field name="natureFacture" type="radio" :value="2" id="2"
                        class="form-check-input" v-model="natureFacture" />
                      <label class="form-check-label" for="2">
                        Electricité
                      </label>
                    </div>
                  </div>
                  <ErrorMessage name="natureFacture" class="text-danger" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6  col-sm-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Marché<span class="text-danger">*</span>
                  </label>
                  <Field name="marche" v-slot="{ field }">
                    <Multiselect :options="marcheOptions" mode="tags" multiple="true" :searchable="true" v-model="field.value" v-bind="field"
                      placeholder="Sélectionner le marché" />
                  </Field>
                  <ErrorMessage name="marche" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6  col-sm-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Type Emplacement
                  </label>
                  <Field name="type" v-slot="{ field }">
                    <Multiselect :options="typeEmplacementOptions"  mode="tags" multiple="true" :searchable="true" v-model="field.value"
                      v-bind="field" placeholder="Sélectionner le type" />
                  </Field>
                  <ErrorMessage name="type" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4 mb-3  col-sm-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black mb-10">
                    Mois<span class="text-danger">*</span>
                  </label>
                  <Field name="mois" v-model="mois" type="text" v-slot="{ field }">
                    <Multiselect 
                      :searchable="true" 
                      :options="moisList" 
                      v-model="field.value" 
                      v-bind="field" 
                      placeholder="Sélectionner le mois" 
                    />
                  </Field>
                  <ErrorMessage name="mois" class="text-danger" />
                </div>
              </div>


              <div class="col-md-4 col-sm-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Année <span class="text-danger">*</span>
                  </label>
                  <Field name="annee" v-model="annee" v-slot="{ field }">
                    <Multiselect :options="years" :searchable="true" v-model="field.value" v-bind="field"
                      placeholder="Sélectionner une année" />
                  </Field>
                  <ErrorMessage name="annee" class="text-danger" />
                </div>
              </div>

              <div class="col-md-4 col-sm-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Date limite de paiement <span class="text-danger">*</span>
                  </label>
                  <Field name="dateLimit" type="date"  v-model="dateLimit"
                  class="form-control shadow-none fs-md-15 text-black"/>
                  <ErrorMessage name="dateLimit" class="text-danger"/>
                </div>
              </div>

              <div class="col-md-12">
                <div class="d-flex align-items-center ">
                  <button
                    class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                    :disabled="isImporting">
                    <span v-if="isImporting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                      type="submit"></span>
                    <span v-if="!isImporting">Générer</span>
                  </button>
                  <button type="button" data-bs-dismiss="modal" aria-label="Close"
                    class="btn btn-danger transition border-0 lh-1 fw-medium">
                    <i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                    <span class="position-relative"></span>Annuler
                  </button>
                </div>
              </div>
            </div>
            <!-- Affichage de la progression -->
            <div v-if="progress !== 0" class="progress mt-4">
              <div class="progress-bar" :style="{ width: progress + '%' }">
                {{ progress }}%
              </div>
            </div>
          </Form>
        </div>
        <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import { defineComponent, onMounted, ref, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import { error, hideModal, success, } from '@/utils/utils';
import { EnvoieLotDetail } from '@/models/EnvoieLotDetail';
import Multiselect from '@vueform/multiselect';
import router from '@/router';
import SocketService from "@/services/SocketService";
import Swal from 'sweetalert2';

export default defineComponent({
  name: "GenererFactureModal",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
  },
  setup: (_, { emit }) => {
    const factureSchema = Yup.object().shape({
      natureFacture:Yup.number().required("La nature est obligatoire"),
      type: Yup.array().notRequired(),
      marche: Yup.array().required('Le marché est obligatoire'),
      mois: Yup.string().required('Le mois est obligatoire'),
      annee: Yup.string().required('L\'année est obligatoire'),
      dateLimit: Yup.date().required('La date limite de paiement est obligatoire'),
    });

      const moisList = [
        'Janvier',
        'Février',
        'Mars',
        'Avril',
        'Mai',
        'Juin',
        'Juillet',
        'Août',
        'Septembre',
        'Octobre',
        'Novembre',
        'Décembre',
      ];

    const natureFacture = ref(0)
    const isImporting = ref(false);
    const factureForm = ref<null | EnvoieLotDetail>(null);
    const marcheOptions = ref([]);
    const typeEmplacementOptions = ref([]);
    const modeleOptions = ref([]);
    const genererFactureModalRef = ref<null | HTMLElement>(null);
    const year = ref(new Date().getFullYear());
    const annee = ref();
    const mois = ref();
    const currentYear = new Date().getFullYear();
    const years = ref(
      Array.from({ length: 3 }, (_, i) => {
        const year = currentYear - 1;
        return { value: year + i, label: year + i };
      })
    );
    

    // État de la progression
    const progress = ref<number | null>(0);
    const progressNiveau = ref<string | null>("");
    const message = ref<string | null>(null);


    // Écouter les événements WebSocket liés à la génération de facture
    const listenForFactureUpdates = () => {
      SocketService.on("factureProgress", (data) => {
        if (data) {
          progress.value = Math.round((data.facturesGenerees / data.totalFactures) * 100);
          progressNiveau.value = `${data.facturesGenerees} sur ${data.totalFactures}`;
          message.value = data.message;
          console.log("Facture mise à jour:", data);
          // success("La facture a été générée avec succès.");
        }
      });
    };

    const lancerSweet = async () => {
      let timerInterval: ReturnType<typeof setInterval>; // Typage pour éviter des erreurs

      await Swal.fire({
        title: 'Génération en cours...',
        html: 'Progression de la génération <p></p> <br> <b style="color:#005e48;"></b>',
        allowOutsideClick: false, // Empêcher la fermeture accidentelle
        showConfirmButton: false, // Cacher le bouton de confirmation
        didOpen: () => {
          Swal.showLoading(); // Afficher l'icône de chargement

          const b = Swal.getHtmlContainer()?.querySelector('b');
          const p = Swal.getHtmlContainer()?.querySelector('p');
          if (b && p) {
            timerInterval = setInterval(() => {
              if (progressNiveau.value !== null) {
                console.log("Progression ===> ", progressNiveau.value);
                p.textContent = message.value ? ` ${message.value}` : 'Veuillez patienter...';
                b.textContent = `${progressNiveau.value}`; // Mise à jour dynamique
              }

              // Quand la progression atteint 100%, on ferme l'alerte
              if (progress.value === 100) {
                clearInterval(timerInterval);
                progressNiveau.value = null;
                progress.value = 0;
                Swal.hideLoading();
                Swal.close(); // Fermer automatiquement SweetAlert
              }
            }, 100); // Vérifier toutes les 500ms
          }
        },
        willClose: () => {
          clearInterval(timerInterval); // Nettoyer l'intervalle au cas où
          progress.value = 0; // Réinitialiser la progression
          progressNiveau.value = null; // Réinitialiser la progression
        }
      });
    };



    // Fonction de génération des factures
    const genererFactures = async (values: any, factureForm) => {
      try {
        console.log("genererFactures ===> ", values);
        isImporting.value = true;
        values.estGenerer = 1;
        // ENREGISTREMENT DES REDEVANCES
        lancerSweet();
        const { data } = await ApiService.post('/lot/facture', values);
        if (data.code === 201) {
          isImporting.value = false;

          progressNiveau.value = null;
          progress.value = 0;
          success(data.message);
          emit('close');
          factureForm.resetForm();
          hideModal(genererFactureModalRef.value);
          router.push('/liste-facture');
        }
      } catch (err) {
        isImporting.value = false;
        error((err as any).response.data.message);
      }
    };

    // Fonction pour récupérer les marchés
    const fetchMarches = async () => {
      return ApiService.get('/all/marche')
        .then(({ data }) => {
          if (data.code === 200) {
            marcheOptions.value = data.data.data.map((marche: any) => ({
              value: marche.id,
              label: marche.code + ' [ ' + marche.libelle + ' ] ',
            }));
          }
        })
        .catch((response) => {
          error(response.data.message);
        });
    };

    // Fonction pour récupérer les types d'emplacements
    const fetchTypeEmplacements = async () => {
      return ApiService.get('/all/type')
      .then(({ data }) => {
        if (data.code === 200) {
          typeEmplacementOptions.value = data.data.data.map((typeEmplacement: any) => ({
            value: typeEmplacement.id,
            label: typeEmplacement.code + ' [ ' + typeEmplacement.libelle + ' ] ',
          }));
        }
      })
      .catch((response) => {
        error(response.data.message);
      });
    };

    onMounted(() => {
      // Écoute des événements lorsque le composant est monté
      listenForFactureUpdates();
      fetchMarches();
      fetchTypeEmplacements();
    });

 

    // watch([mois, annee], (newMois) => {
    //   console.log("Mois sélectionné:", newMois);
    //   if(year.value && mois.value){
    //     const moisNumero = moisList.indexOf(newMois[0]);
    //     dateLimit.value = getDateLimitePaiement(newMois[0], newMois[1]);
    //   }
    // });

    //  const getCurrentDate = () => {
    //       const today = new Date();
    //       const day = String(today.getDate()).padStart(2, '0');
    //       const month = String(today.getMonth() + 1).padStart(2, '0');
    //       const year = today.getFullYear();
    //       return `${year}-${month}-${day}`;
    // }

    

    // function getDateLimitePaiement(moisNom: string, annee: number): string {
    //   const moisIndex = moisList.indexOf(moisNom);
    //   let nextMonth = moisIndex;
    //   let nextYear = annee;
    //   const monthStr = String(nextMonth + 1).padStart(2, '0');
    //   return `${nextYear}-${monthStr}-05`;
    // }

    // const dateLimit = ref(getCurrentDate());
    const dateLimit = ref();

    return {
      factureSchema,
      factureForm,
      marcheOptions,
      isImporting,
      typeEmplacementOptions,
      years,
      genererFactureModalRef,
      progress,
      mois,
      genererFactures,
      lancerSweet,
      natureFacture,
      // getCurrentDate,
      moisList,
      dateLimit,
      annee
    };
  },
});
</script>


<style src="@vueform/multiselect/themes/default.css"></style>